export default "__VITE_ASSET__e6836923__"